var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPepperHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08783 9.69305C5.28536 7.40365 4.82113 4.29866 4.10482 2.47007C3.99809 2.1976 4.2645 1.9013 4.51839 2.03175C8.13262 3.88874 12.8466 8.39985 7.5857 14.379C6.94315 12.817 6.16655 10.3625 6.94315 9.02363C7.01247 8.90411 2.31123 10.3625 4.23889 15.0484C3.16797 14.379 0.517615 12.3707 3.08783 9.69305Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1923 5.05867C20.9458 4.71741 20.4796 4.64824 20.1509 4.90419C19.8222 5.16015 19.7556 5.64429 20.0021 5.98556C20.3619 6.48359 20.8203 7.67857 20.2127 8.83854C20.4906 9.02151 20.7439 9.23361 20.9722 9.46944C21.1039 9.60555 21.2252 9.74726 21.3369 9.8929C22.6035 7.91833 21.7685 5.85633 21.1923 5.05867Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89327 18.9104C7.95276 18.9104 10.7309 17.6596 12.7793 15.6237C13.4904 14.917 13.8586 13.9644 14.2293 13.0053C14.4382 12.4649 14.6479 11.9224 14.9201 11.4207C15.4433 10.4566 16.3567 9.64155 17.8696 9.64155C19.9294 9.64155 20.8434 11.1523 21.1781 12.493C21.3836 13.3159 21.2327 14.1818 20.9085 14.9624C19.1869 19.1087 15.4961 22 10.8444 22C8.48767 22 6.29789 21.2579 4.47999 19.9864C4.00222 19.6522 4.31723 18.9104 4.89327 18.9104Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepperHot);
export default __webpack_public_path__ + "static/media/pepper-hot.f576456bcf3d02293591c07bfe0bd685.svg";
export { ForwardRef as ReactComponent };